import { axios, BaseApiUrl } from '../axios_config';


// 获取移动端待出库列表
export const getList = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/GetOutboundList`, { ...params }).then(res => res.data)
}

// 获取移动端待扫箱出库列表
export const getListScan = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/GetOutboundScanList`, { ...params }).then(res => res.data)
}

// 获取移动端出库信息
export const getOutbound = params =>{
    return axios.get(`${BaseApiUrl}/TFMobile/GetOutboundDetail`, { params }).then(res => res.data);
}

// 获取移动端扫描出库信息
export const getOutboundScan = params =>{
    return axios.get(`${BaseApiUrl}/TFMobile/GetOutboundScanDetail`, { params }).then(res => res.data);
}

// 获取移动端待出库箱子列表
export const getBoxList = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/GetOutBoxDetail`, { ...params }).then(res => res.data)
}

// 获取移动端扫码装柜详情
export const getScanBoxList = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/GetOutBoxScanDetail`, { ...params }).then(res => res.data)
}

// 扫码装车点数列表
export const getPointsDetail = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/GetPointsDetail`, { ...params }).then(res => res.data)
}

// 删除不发箱
export const DeleteScanBoxInfo = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/DeleteScanBoxInfo`, { ...params }).then(res => res.data);
}

// 扫描不发箱
export const ScanCodeNoDeliveryBox = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/ScanCodeNoDeliveryBox`, { ...params }).then(res => res.data);
}
//扫码装柜
export const submitBox = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/SubmitBox`, { ...params }).then(res => res.data);
}

// 提交不发货箱子
export const notScanBoxSubmit = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/NotScanBoxSubmit`, { ...params }).then(res => res.data);
}

// 提交点数记录
export const loadingBoxPoints = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/LoadingBoxPoints`, { ...params }).then(res => res.data);
}

// 移动端确认出库
export const PutOnCarSubmit = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/OutboundSubmit`, { ...params }).then(res => res.data);
}

// 移动端按票装车
export const loadOut = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/LoadOut`, { ...params }).then(res => res.data);
}

// 移动端扫码装柜出库
export const OutboundScanSubmit = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/OutboundScanSubmit`, { ...params }).then(res => res.data);
}

